export default function InfoIcon({ width, height }) {
  return (
    <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="5" width="56" height="56" rx="28" fill="#FEF0C7" />
      <path d="M32.9997 37.6668V33.0002M32.9997 28.3335H33.0113M44.6663 33.0002C44.6663 39.4435 39.443 44.6668 32.9997 44.6668C26.5564 44.6668 21.333 39.4435 21.333 33.0002C21.333 26.5568 26.5564 21.3335 32.9997 21.3335C39.443 21.3335 44.6663 26.5568 44.6663 33.0002Z" stroke="#DC6803" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <rect x="5" y="5" width="56" height="56" rx="28" stroke="#FFFAEB" stroke-width="10" />
    </svg>

  );
}
